export default {
	'no-items-to-show': 'No items found in plan for this month.',
	'material-name': 'Material Name',
	'form-type': 'Form Type',
	quantity: 'Quantity',
	classification: 'Classification',
}
